import { render } from "./edit-buyer.vue?vue&type=template&id=1cb8e8ac&lang=pug"
import script from "./edit-buyer.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-buyer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__